import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { Table, Icon, Alert } from "design-react-kit";

import secureLocalStorage from "react-secure-storage";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";

const NotificationVerificationF24Table = ({
  items,
  columns,
  getInvalidNotificationsPaymentData,
}) => {
  const [results, setResults] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
  }, [items]);

  const filterHandler = (e, items) => {
    const value = e.target.value;
    let filteredResults = "";
    if (value === "") {
      filteredResults = items;
    } else if (
      e.nativeEvent.inputType === "deleteContentBackward" ||
      e.nativeEvent.inputType === "deleteContentForward"
    ) {
      filteredResults = items.filter((item) => {
        return (
          item.description.toLowerCase().includes(value.toLowerCase()) ||
          item.clientCodeName.toLowerCase().includes(value.toLowerCase())
        );
      });
    } else {
      filteredResults = items.filter((item) => {
        return (
          item.description.toLowerCase().includes(value.toLowerCase()) ||
          item.clientCodeName.toLowerCase().includes(value.toLowerCase())
        );
      });
    }
    return filteredResults;
  };

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Cerca"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getInvalidNotificationsPaymentData()}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.id}>
                    <td className="creationDate text-center text-nowrap">
                      {result.creationDate}
                    </td>
                    <td className="description">{result.description}</td>
                    <td className="clientCodeName text-center text-nowrap">
                      {result.clientCodeName}
                    </td>
                    <td className="text-center edit-invalid-notification">
                      <Icon
                        icon="it-pencil"
                        fill="#06c"
                        role="button"
                        onClick={(e) => {
                          secureLocalStorage.setItem(
                            "notificationDescription",
                            result.description
                          );
                          navigate(
                            `/notificheAI/verificationf24/edit/${result.id}/${result.clientId}`
                          );
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            {results !== null && results?.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </Fragment>
  );
};

export default NotificationVerificationF24Table;
